export default __webpack_public_path__ + "static/media/GG.b08bf450.svg";